export const FETCH_START = 'crimeCategory/FETCH_START'
export const FETCH_SUCCESS = 'crimeCategory/FETCH_SUCCESS'
export const FETCH_FAILURE = 'crimeCategory/FETCH_FAILURE'
